import { render } from "./index.vue?vue&type=template&id=919bd4b8"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=919bd4b8&lang=less"
script.render = render

export default script